module.exports = __webpack_public_path__ + "img/avatar.fda2b552.png";